import { reducer as formReducer } from 'redux-form';
import { globalizationKey, globalizationReducer } from '@mews/globalization';
import { MODULE_NAME as entitiesKey, reducer as entitiesReducer } from '@mews-commander/legacy-entities';
import { MODULE_NAME as websocketsKey, reducer as websocketsReducer } from '../core/websockets';

const accountUnawareReducers = {
    [globalizationKey]: globalizationReducer,
    [entitiesKey]: entitiesReducer,
};

const accountAwareReducers = {
    [websocketsKey]: websocketsReducer,
    form: formReducer,
};

export const coreReducers = {
    ...accountUnawareReducers,
    ...accountAwareReducers,
};
